import type { RegionArea } from '@core/Entities/Location/RegionArea.entity';
import type { RegionAreaAtom } from '@search/Atoms/RegionAtom.entity';

const maybeToNumber = (optionalString: string | undefined) =>
  optionalString ? Number(optionalString) : undefined;

export const regionFromLocationCombinedParams = (selectedRegion: RegionArea): RegionAreaAtom => {
  return {
    key: selectedRegion.id,
    displayName: selectedRegion.shortName,
    region: selectedRegion.id,
    location: {
      lat: (maybeToNumber(selectedRegion.lat) ?? selectedRegion.position?.lat)!,
      lon: (maybeToNumber(selectedRegion.lon) ?? selectedRegion.position?.lon)!,
    },
    postcode: selectedRegion.postcode,
    regionCode: selectedRegion.regionCode ?? '',
  };
};

export const areaFromLocationCombinedParams = (selectedArea: RegionArea): RegionAreaAtom => {
  const areaName = (selectedArea.areaCode || selectedArea.area)!;

  return {
    key: areaName,
    displayName: selectedArea.shortName,
    region: (selectedArea.regionCode || selectedArea.region)!,
    location: {
      lat: (maybeToNumber(selectedArea.lat) ?? selectedArea.position?.lat)!,
      lon: (maybeToNumber(selectedArea.lon) ?? selectedArea.position?.lon)!,
    },
    postcode: selectedArea.postcode,
    areaCode: areaName,
  };
};
